import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterButton } from 'components/WrappedComponents';
import { FilterDashboardJuridiction } from 'hooks/search/useSearchJuridictionQuery';

import FilterFormJuridiction from './FilterFormJuridiction';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardJuridiction>) => void;
  filter: Partial<FilterDashboardJuridiction>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid, ...formFilter } = filter;
  function setFormFilter(value: Partial<FilterDashboardJuridiction>) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  function setDisplayInvalidJuridiction(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <FilterFormJuridiction filter={data} setFilter={setData} />
        )}
      </FilterButton>
      <AntdCheckbox
        checked={!valid}
        onChange={setDisplayInvalidJuridiction}
        className="checkbox-juridictions-inactives"
      >
        Afficher les juridictions inactives
      </AntdCheckbox>
    </div>
  );
}
